import { getAllData } from "apis/customApiHandler";
import Spinner from "components/Spinner";
import useDebounce from "hooks/useDebounce";
import React, { useState } from "react";
import { useQuery } from "react-query";
import { Input } from "styled";
import { TD, TH } from "styled/table";

const StockTansferHistory = () => {
  const [search, setSearch] = useState("");

  const debouncedValue = useDebounce(search, 1000);
  const { data: stocks, isLoading } = useQuery(
    ["stock-tansfers", debouncedValue && debouncedValue],
    () =>
      getAllData("/tyre/stockTansfers", {
        searchQuery: debouncedValue,
        "notInList%5Btype%5D": "EXTERNAL"
      })
  );

  return (
    <div>
      <div className="mx-10 my-2">
        <div className="mt-8 flex justify-start gap-6 items-center flex-wrap lg:flex-nowrap">
          <div className="relative w-full">
            <Input
              type="search"
              placeholder="Search Here"
              onChange={(e) => {
                setSearch(e.target.value);
              }}
            />
          </div>
        </div>
      </div>
      {isLoading ? (
        <Spinner />
      ) : (
        <div className="flex flex-col m-2 lg:m-10">
          <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
              <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <TH scope="col">S.N.</TH>
                      <TH scope="col">Stencil Numbers</TH>
                      <TH scope="col">From Hub</TH>
                      <TH scope="col">To Hub</TH>
                      <TH scope="col">From Fleet</TH>
                      <TH scope="col">To Fleet</TH>
                      <TH scope="col">Updated By</TH>
                      <TH scope="col">Updated Time</TH>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {stocks?.data &&
                      stocks?.data.map((item, index) => (
                        <ViewList data={item} key={item?._id} index={index} />
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StockTansferHistory;

const ViewList = ({ data, index }) => {
  return (
    <tr key={data._id} className={`${index % 2 !== 0 && "bg-gray-100"}`}>
      <TD>{index + 1}</TD>
      <TD className="stock-transfers-stencil-numbers">
        {data.stencilNumbers.join(", ")}
      </TD>
      <TD>{data.fromHub}</TD>
      <TD>{data.toHub}</TD>
      <TD>{data.fromFleet}</TD>
      <TD>{data.toFleet}</TD>
      <TD>
        {data.updatedBy && data.updatedBy ? data.updatedBy : "---"}
      </TD>
      <TD>{new Date(data.updatedAt).toLocaleDateString("en-GB").replace(/\//g, '-')}</TD>
    </tr>
  );
};
